import * as types from '@/redux/contains/types';
import * as status from '@/common/enum'
import * as api from '@/common/api';
import * as axiosWrapper from '@/redux/contains/axios-wrapper';
import Swal from 'sweetalert2'

export const account_success = (account) => {
    return {
        type: types.ACCOUNT_CHANGE,
        account
    }
}


const getUserInfo = () => dispatch => {
    axiosWrapper.axiosWithHeaders("get", api.getUserInfo, null)
        .then(response => {
            if (response.status === status.STATUS_RESPONSE_OK && response.data) {
                const {
                    data
                } = response;
                // console.log(data);
                if (data.status === status.STATUS_RESPONSE_OK) {
                    dispatch(account_success(data.result))
                } else {
                    Swal.fire({
                        title: 'Chi tiết tài khoản',
                        text: data.message,
                        imageUrl: '/img/octopus/error.svg',
                        imageWidth: 109,
                        imageHeight: 98,
                        imageAlt: 'Error',
                        confirmButtonColor: '#76cc68',
                        showCloseButton: true
                    })
                }
            } else {
                Swal.fire({
                    title: 'Chi tiết tài khoản',
                    text: response.statusText,
                    imageUrl: '/img/octopus/error.svg',
                    imageWidth: 109,
                    imageHeight: 98,
                    imageAlt: 'Error',
                    confirmButtonColor: '#76cc68',
                    showCloseButton: true
                })
            }
        })
        .catch((err) => {
            Swal.fire({
                title: 'Chi tiết tài khoản',
                text: err.toString(),
                imageUrl: '/img/octopus/error.svg',
                imageWidth: 109,
                imageHeight: 98,
                imageAlt: 'Error',
                confirmButtonColor: '#76cc68',
                showCloseButton: true
            })
        })
}

const getUserInfov2 = () => {
    return axiosWrapper.axiosWithHeaders("get", api.getUserInfo, null);
}

const validateOctopus = () => {
    return axiosWrapper.axiosWithHeaders("get", `${api.validateOctopus}`, null)
}

export {
    getUserInfo,
    getUserInfov2,
    validateOctopus
}